import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import { ExcelExportConfig } from '../models/export/excel-export.config';

export type Tuple = [any[], any[]];
export class Excel {
    public Reader: FileReader = new FileReader();
    private _SheetsData: any[] = [];
    public Success: boolean = false;
    public FinalData: any[] = [];
    private _Workbook: XLSX.WorkBook;

    constructor() { }

    public ObjectToExcelNewPage(SheetName: string, json: any[]) {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        this._Workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(this._Workbook, worksheet, SheetName);
    }

    public WriteFile(FileName: string) {
        XLSX.writeFile(this._Workbook, FileName);
    }

    public ObjectToExcelAndWrite(json: any[], SheetName: string, FileName: string) {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        const workbook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, SheetName);
        XLSX.writeFile(workbook, FileName);

    }

    public exportWithConfig<T>(
        data: T[],
        config: ExcelExportConfig
    ): void {

        const worksheet = XLSX.utils.json_to_sheet(
            data,
            { header: config.headers }
        );

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            config.sheetName
        );

        XLSX.writeFile(workbook, config.fileName);
    }
}